<template>
  <div class="modifyAvator">
    <div class="left">
      <vue-cropper ref="cropper" :img="option.img" :output-size="option.size" :output-type="option.outputType"
        :info="true" :full="option.full" :can-move="option.canMove" :can-move-box="option.canMoveBox"
        :original="option.original" :auto-crop="option.autoCrop" :fixed="option.fixed"
        :fixed-number="option.fixedNumber" :center-box="option.centerBox" :info-true="option.infoTrue"
        :fixed-box="option.fixedBox" :auto-crop-width="option.autoCropWidth" :auto-crop-height="option.autoCropHeight"
        @realTime="realTime" />

      <div class="typeface" style="font-size: 12px">
        支持jpg，jpeg，png，bmp格式，大小不超过10MB
      </div>

      <el-upload ref="upload" :before-upload="uploadChange" :show-file-list="false" :file-list="fileList"
        class="upload-demo" action="/" accept=".jpg,.jpeg,.png,.bmp,.JPG,.JPEG,.PNG,.BMP">
        <el-button size="small" type="text" icon="el-icon-plus">重新选择</el-button>
      </el-upload>

      <div>
        <el-button :loading="loading" size="small" type="primary" style="width: 444px; margin-top: 10px"
          @click="uploadImg">
          保存
        </el-button>
      </div>
    </div>
    <div class="right">
      <div class="right_up">
        <div style="width: 200px; height: 200px" class="avatar-upload-preview">
          <div :style="previewNomal">
            <div :style="previews.div">
              <img :src="previews.url" :style="previews.img" alt="" />
            </div>
          </div>
        </div>

        <div class="typeface">200 * 200 像素</div>
      </div>
      <div class="right_up">
        <div style="width: 120px; height: 120px" class="avatar-upload-preview">
          <div :style="previewMiddle">
            <div :style="previews.div">
              <img :src="previews.url" :style="previews.img" alt="" />
            </div>
          </div>
        </div>
        <div class="typeface">120 * 120 像素</div>
      </div>
      <div class="right_up">
        <div style="width: 32px; height: 32px" class="avatar-upload-preview">
          <div :style="previewSmall">
            <div :style="previews.div">
              <img :src="previews.url" :style="previews.img" alt="" />
            </div>
          </div>
        </div>
        <div class="typeface">32 * 32 像素</div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueCropper } from "vue-cropper";
import request from "@/CommonDP/service/userCenter-service";
import { mapState } from "vuex";
import { gettouxAvatar } from "@/CommonDP/utils";
export default {
  name: "ModifyAvator",
  components: {
    VueCropper
  },
  inject: ["reload"],
  data() {
    return {
      fileList: [],
      loading: false,

      // dialogVisible: false,
      option: {
        img: "", // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 1, // 裁剪生成图片的质量
        outputType: "jpeg", // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 200, // 默认生成截图框宽度
        autoCropHeight: 200, //
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [200, 200], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },

      previews: {},

      previewNomal: {},
      previewMiddle: {},
      previewSmall: {}
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      userAvator: (state) => state.user.avatar,
      userInfo: (state) => state.user.userInfo
    })
  },
  created() {
    this.option.img = gettouxAvatar(this.userInfo.userId);
  },
  methods: {
    realTime(data) {
      this.previews = data;

      const common = {
        width: data.w + "px",
        height: data.h + "px",
        overflow: "hidden",
        margin: "0"
      };

      this.previewNomal = {
        ...common,
        zoom: 200 / data.w
      };
      this.previewMiddle = {
        ...common,
        zoom: 120 / data.w
      };
      this.previewSmall = {
        ...common,
        zoom: 32 / data.w
      };
    },
    // 上传图片
    uploadImg() {
      this.$refs.cropper.getCropBlob((data) => {
        const formData = new FormData();
        formData.append("avatarfile", data);
        this.loading = true;
        request.uploadAvatar(formData).then((response) => {
          this.loading = false;
          const imgUrl = gettouxAvatar(this.user.userId, this.user.token.substring(7));
          this.$store.commit("SET_AVATAR", imgUrl);
          this.reload();
          this.$message.success("上传成功");
        });
      });
    },
    // 方法判断
    uploadChange(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "jpg";
      const extension2 = testmsg === "png";
      const extension3 = testmsg === "JPG";
      const extension4 = testmsg === "JPEG";
      const extension5 = testmsg === "PNG";
      const extension6 = testmsg === "jpeg";
      const extension7 = testmsg === "BMP";
      const extension8 = testmsg === "bmp";
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (
        !extension &&
        !extension2 &&
        !extension3 &&
        !extension4 &&
        !extension5 &&
        !extension6 &&
        !extension7 &&
        !extension8
      ) {
        this.$message({
          message: "上传文件只能是 jpg、png、JPG、JPEG、PNG、jpeg、BMP、bmp格式!",
          type: "warning"
        });
        return false;
      }
      if (!isLt10M) {
        this.$message.error("上传图片大小不能超过 10MB!");
        return false;
      }

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.option.img = reader.result;
      };
    }
  }
};
</script>

<style lang="scss">
.modifyAvator {
  padding: 50px;
  display: flex;
  box-sizing: border-box;
  .left {
    width: 444px;
    height: 444px;
    margin-right: 23px;
    .el-avatar {
      width: 100%;
      height: 100%;
    }
  }
  .typeface {
    color: var(--info-color)9;
    font-size: 14px;
    line-height: 36px;
  }
  .el-avatar > img {
    width: 100%;
  }

  .el-upload {
    width: 100%;
    height: 100%;
  }
  .cropper {
    width: auto;
    height: 300px;
  }
  .avatar-upload-preview {
    background: #c0c4cc;
    overflow: hidden;
  }
}
</style>
